export default __webpack_public_path__ + "static/media/1.f6526ce1.png";